// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

declare const require: any;
export const environment = {
  production: false,
  SERVER_URL: 'https://testdeaapi.passer.live',
  serverUrlPasser: 'https://testapi.passer.live',
  serverlessUrl: 'https://sls.passer.live/development',
  serverUrlPasserPolicy: 'https://testing.passer.live/legal/business-partner',
  serverUrlPasserPublicTransp: 'https://testing.passer.live/enterprises',
  serverUrlCatalogs: 'https://testcatalogs.passer.live/api',
  serverUrlDriver: 'https://testdriverapi.passer.live/api',
  serverLambda: 'https://functionsapi.passer.live/develop',
  socket_url: 'https://testmapsocket.passer.live',
  socket_ticket_url: 'https://testsockets.passer.live',
  socket_print_url: 'https://testprintsocket,passer.live',
  passer_connect: 'https://testenterprisesconnect.passer.live/doc/',
  serverURLReportTransactions:
    'https://testreports.passer.live/api/transactions/transactionsAndPayments',
  enviromentCrypto: 'test',
  passerIdP: {
    options: {
      serverUrl: 'https://testidp.passer.live',
      clientId: 'dae',
      clientSecret: 'bar',
      scope: 'openid profile email phone offline_access',
      resource: 'https://testdeaapi.passer.live',
      callbackRecoveryPasswordBaseUrl:
        'https://testing.passer.live/reset-password',
    },
  },
  ffKey: 'dev_gdfZ8yMKOf3wxmzXNQaMLvrLDaMy1LHgLy10DyvO2w',
  deaVersion: require('../../package.json').version,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
